<template>
    <el-container id="main-body-container">
        <!--用户列表-->
        <el-aside width="240px" id="aside">
            <ul v-if="userList.length > 0">
                <li v-for="(user, index) in userList" :key="index" @click="selectUser(user)" :class="{active: user.active }">
                    <i class="el-icon-menu" />
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="点击切换用户"
                        placement="right"
                        v-if="userList.length > 1">
                        <span>{{user.username}}</span>
                    </el-tooltip>
                    <span v-if="userList.length === 1">{{user.username}}</span>
                </li>
            </ul>
        </el-aside>

        <!--主体-->
        <el-container id="main">
            <el-main>
                <el-row id="selectHole" style="background-color: white;padding-left: 10px">
                    <span>请先选择测量点</span>
                    <select v-model="point">
                        <option :value="point" v-for="(point,index) in pointList" :key="index">
                            {{point.label}}
                        </option>
                    </select>
                    <span>请再选择测斜孔</span>
                    <select v-model="hole">
                        <option :value="hole" v-for="(hole,index) in point.value" :key="index">
                            {{hole.hole}}


                        </option>
                    </select>
                    <span>请选择管形算法</span>
                    <select v-model="suanfa">
                        <option :value="suanfa" v-for="(suanfa,index) in suanfaArr" :key="index">
                            {{suanfa.label}}
                        </option>
                    </select>
                </el-row>
                <transition name="el-zoom-in-top">
                    <el-row v-if="JSON.stringify(point) != '{}'"
                            style="margin-top: 15px;background-color: white;height: 60px;line-height: 60px">
                        <span style="margin-right: 15px;margin-left: 10px">导出单日所有原始数据</span>
                        <el-date-picker
                                v-model="datepicker"
                                value-format="yyyy-MM-dd"
                                type="date"
                                style="margin-right: 15px"
                                placeholder="选择日期">
                        </el-date-picker>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="选择日期导出该测量点下所有的单次原始数据"
                            placement="bottom">
                            <el-button size="mini" type="primary" @click="exportNearlyData">导出</el-button>
                        </el-tooltip>
                        <br>
                    </el-row>
                </transition>

                <transition name="el-zoom-in-top" v-if="isProfessionalMode && hole && hole.id">
                    <change-rod :point-id="hole.id"></change-rod>
                </transition>

                <div v-if="times.length > 0 && suanfa.value > 0" style="margin: 15px 0">
                    <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="checkAll"
                        @change="handleCheckAllChange">全选
                    </el-checkbox>
                    <el-checkbox-group v-model="selectedTimes">
                        <el-checkbox-button
                            v-for="time in times"
                            :label="time.unixTime"
                            :key="time.unixTime" style="margin-top: 10px">{{time.dateString}}
                        </el-checkbox-button>
                    </el-checkbox-group>
                </div>
                <transition name="el-zoom-in-top">
                    <el-table :data="tableData" style="width: 100%" v-if="selectedTimes.length > 0 && suanfa.value > 0">
                        <el-table-column label="类型" width="180" class="transition-box">
                            <template slot-scope="scope">
                                <span>{{scope.row.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" class="transition-box">
                            <template slot-scope="scope">

                                <!--管形图-->
                                <el-button
                                    size="mini"
                                    type="primary"
                                    @click="exportTubularData(1)"
                                    v-if="scope.row.type == 1 && suanfa.value == 1">导出CSV文件（自管底起）
                                </el-button>

                                <el-button
                                    size="mini"
                                    type="primary"
                                    @click="getChartData(1)"
                                    v-if="scope.row.type == 1 && suanfa.value == 1">查看管形图（自管底起）
                                </el-button>

                                <el-button
                                    size="mini"
                                    type="primary"
                                    @click="exportTubularData(7)"
                                    v-if="scope.row.type == 1 && suanfa.value == 2">导出CSV文件（自管口起）
                                </el-button>

                                <el-button
                                    size="mini"
                                    type="primary"
                                    @click="getChartData(7)"
                                    v-if="scope.row.type == 1 && suanfa.value == 2">查看管形图（自管口起）
                                </el-button>

                                <!--累计变量-->
                                <el-button
                                    size="mini"
                                    type="primary"
                                    @click="exportAmountDeltaData(1)"
                                    v-if="scope.row.type == 4 && suanfa.value == 1">导出CSV文件（自管底起）
                                </el-button>

                                <el-button
                                    size="mini"
                                    type="primary"
                                    @click="getAmountChartData(1)"
                                    v-if="scope.row.type == 4 && suanfa.value == 1 && selectedTimes.length > 1">
                                    查看累计变量（自管底起）
                                </el-button>

                                <el-button
                                    size="mini"
                                    type="primary"
                                    @click="exportAmountDeltaData(7)"
                                    v-if="scope.row.type == 4 && suanfa.value == 2">导出CSV文件（自管口起）
                                </el-button>

                                <el-button
                                    size="mini"
                                    type="primary"
                                    @click="getAmountChartData(7)"
                                    v-if="scope.row.type == 4 && suanfa.value == 2 && selectedTimes.length > 1">
                                    查看累计变量（自管口起）
                                </el-button>

                                <!--校验和标准差-->
                                <el-button
                                    size="mini"
                                    type="primary"
                                    @click="exportStandard"
                                    v-if="scope.row.type == 2">导出CSV文件
                                </el-button>

                                <el-button
                                    size="mini"
                                    type="primary"
                                    @click="getStandardChartData"
                                    v-if="scope.row.type == 2 && selectedTimes.length > 1">
                                    查看校验和标准差
                                </el-button>

                                <!--单次原始数据-->
                                <el-button
                                    size="mini"
                                    type="primary"
                                    @click="exportSourceData"
                                    v-if="scope.row.type == 3">导出CSV文件
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </transition>

            </el-main>
            <!--弹窗-->
            <el-dialog
                    title=""
                    :visible.sync="dialogVisible"
                    width="30%">
                <span>你想要保存此文件吗？</span>
                <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <a type="button" id="download" @click="dialogVisible = false">保存文件</a>
                </span>
            </el-dialog>
            <el-dialog :title="chartDialogTitle" :visible.sync="chartDialogNormal" width="500px">
                <div id="chartCanvas1" style="width: 460px;height: 800px"></div>
            </el-dialog>
            <el-dialog :title="chartDialogTitle" :visible.sync="chartDialogAmount" width="500px">
                <div id="chartCanvas2" style="width: 460px;height: 800px"></div>
            </el-dialog>
            <el-dialog :title="chartDialogTitle" :visible.sync="chartDialogStandard" width="600px">
                <div id="chartCanvas3" style="width: 560px;height: 300px"></div>
            </el-dialog>


            <!--footer-->
            <el-footer>
                Copyright © <span style="color: #72afd2">苏州瑞茨柏工程监测技术有限公司</span>. All rights reserved.
            </el-footer>
        </el-container>

    </el-container>
</template>

<script>
import professionalModeService from "../js/service/professionalModeService";
import ChangeRod from "./changeRod";
import $ from 'jquery'; //在需要使用的页面中
import MD5 from 'js-md5';
import utils from '../js/utils';

let myVue = {};
export default {
    name: 'mainBody',
    components: {ChangeRod},
    data () {
        return {
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            },
            // isProfessionalMode: professionalModeService.getState(),
            dialogVisible:false,
            browserType:"",
            userList:[],
            pointList:[],
            point: '',
            hole: '',
            times:[],
            time:{},
            selectedTimes:[],
            datepicker:"",
            suanfaArr:[
                {value:'1',label:'自管底起'},
                {value:'2',label:'自管口起'}
            ],
            suanfa:{},
            tableData: [
                {name: '管形图',type:1},
                {name: '累计变量',type:4},
                {name: '校验和',type:2},
                {name: '原始数据',type:3},
            ],
            isIndeterminate:false,
            checkAll: false,
            chartDialogNormal:false,
            chartDialogAmount:false,
            chartDialogStandard:false,
            chartDialogTitle:'',
        }
    },
    computed:{
        isProfessionalMode () {
            return this.$store.state.isProfessionalMode;
        }
    },
    methods:{
        //画图:校验和标准差
        drawStandardChart:function (legendData,xAxisData,seriesData) {
            let option = {
                tooltip: {
                    axisPointer: {
                        type: 'cross'
                    }
                },
                legend: {
                    icon: "circle",
                    top: 0,
                    data: legendData
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    top: 30,
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxisData.map(function (str) {
                            return str.replace(' ', '\n')
                        })
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        position:'top',
                        max: function (value) {
                            if(value.max > 1){
                                return value.max
                            }else {
                                return 1
                            }
                        },
                    }
                ],
                series: seriesData
            };
            this.myChart = this.$echarts.init(document.getElementById('chartCanvas3'));
            this.myChart.clear();
            this.myChart.setOption(option);
        },
        //画图:管形图、累计变量
        drawChart:function (legendData,yAxisData,seriesData,type) {
            // type  1:管形 2:累计变量

            let type_1_filter_number = 40;
            let type_2_filter_number = 20;

            function setMin(value){
                if(type === 1){
                    let max = Math.max(type_1_filter_number,value.max);
                    let min = Math.min(-type_1_filter_number,value.min);
                    let difference = max - min;
                    return Number(value.min - difference).toPrecision(2);
                }else if(type === 2){
                    let max = Math.max(type_2_filter_number,value.max);
                    let min = Math.min(-type_2_filter_number,value.min);
                    let difference = max - min;
                    return Number(value.min - difference).toPrecision(2);
                }else{
                    return Number(Math.ceil(value.min)).toPrecision(2);
                }
            }

            function setMax(value){
                if(type === 1){
                    let max = Math.max(type_1_filter_number,value.max);
                    let min = Math.min(-type_1_filter_number,value.min);
                    let difference = max - min;
                    return Number(value.max + difference).toPrecision(2);
                }else if(type === 2){
                    let max = Math.max(type_2_filter_number,value.max);
                    let min = Math.min(-type_2_filter_number,value.min);
                    let difference = max - min;
                    return Number(value.max + difference).toPrecision(2);
                }else{
                    return Number(Math.ceil(value.max)).toPrecision(2);
                }
            }

            function clearMin(value) {
                let max = value.max;
                let min = value.min;
                let difference = max - min;
                return Number(value.min - difference/20).toPrecision(2);
            }

            function clearMax(value) {
                let max = value.max;
                let min = value.min;
                let difference = max - min;
                return Number(value.max + difference/20).toPrecision(2);
            }

            let option = {
                title: {
                    left: 'center',
                    text: this.chartDialogTitle,
                },
                toolbox:{
                    show: true,
                    left: 40,
                    top: 25,
                    itemSize: 20,
                    showTitle:true,
                    feature: {
                        saveAsImage: {
                            type:'jpeg',
                            pixelRatio: 1,
                        },
                        myMinMaxClear: {
                            show: true,
                            title: '  ',
                            icon: 'm184,200l106,-148.5l106,148.5l-106,148.5l-106,-148.5z',
                            onclick: function (){
                                option.xAxis[0].min = setMin;
                                option.xAxis[0].max = setMax;
                                myVue.myChart.setOption(option);
                            }
                        },
                        myMinMaxReset: {
                            show: true,
                            title: '  ',
                            icon: 'm110.47672,199.99999l179.52328,-78.97669l179.52328,78.97669l-179.52328,78.97669l-179.52328,-78.97669z',
                            onclick: function (){
                                option.xAxis[0].min = clearMin;
                                option.xAxis[0].max = clearMax;
                                myVue.myChart.setOption(option);
                            }
                        },
                        mySelectAll: {
                            show: true,
                            title: '全选',
                            icon: 'path://M511.1 957.94c-246.456 0-446.857-200.401-446.857-446.859S264.644 64.223 511.1 64.223c246.457 0 446.858 200.401 446.858 446.858S757.557 957.94 511.1 957.94z m0-851.396c-222.806 0-404.537 181.73-404.537 404.537S288.295 915.619 511.1 915.619c222.807 0 404.537-181.73 404.537-404.537S734.53 106.544 511.1 106.544z m167.417 262.017L447.619 601.325 343.685 496.767c-9.335-9.335-24.895-9.335-34.853 0-9.335 9.335-9.335 24.895 0 34.853l121.984 121.983c9.336 9.336 24.895 9.336 34.853 0 1.244-1.244 1.866-2.489 3.112-3.733l245.211-246.457c9.336-9.335 9.336-24.895 0-34.852-9.959-9.959-25.518-9.959-35.475 0z',
                            onclick: function () {
                                let obj = {};
                                option.legend.data.map(function (item) {
                                    obj[item] = true;
                                });
                                option.legend.selected=obj;
                                myVue.myChart.setOption(option);
                            }
                        },
                        mySelectNone: {
                            show: true,
                            title: '不选',
                            icon: 'path://M512 1024C229.2224 1024 0 794.7776 0 512S229.2224 0 512 0s512 229.2224 512 512-229.2224 512-512 512z m0-972.8C257.5104 51.2 51.2 257.5104 51.2 512s206.3104 460.8 460.8 460.8 460.8-206.3104 460.8-460.8S766.4896 51.2 512 51.2z',
                            onclick: function () {
                                let obj = {};
                                option.legend.data.map(function (item) {
                                    obj[item] = false;
                                });
                                option.legend.selected=obj;
                                myVue.myChart.setOption(option);
                            }
                        },
                    }
                },
                tooltip: {
                    trigger: 'item',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                legend: {
                    type: 'scroll',
                    orient: 'vertical',
                    icon: "circle",
                    left: 2,
                    top: 70,
                    bottom: 20,
                    data: legendData
                },
                grid: {
                    left: '42%',
                    right: '2%',
                    top: 30,
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: [
                    {
                        type: 'category',
                        data: yAxisData,
                    }
                ],
                xAxis: [
                    {
                        type: 'value',
                        position:'top',
                        axisTick: {
                            show: true
                        },
                        min: function (value) {
                            return setMin(value);
                        },
                        max: function (value) {
                            return setMax(value);
                        }
                    }
                ],
                series: seriesData
            };
            this.myChart = this.$echarts.init(document.getElementById('chartCanvas' + type));
            this.myChart.clear();
            this.myChart.setOption(option);
        },

        //获取数据：校验和标准差图
        getStandardChartData:function () {
            let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
            this.$http.get('/front/data/exportStandardDeviationSourceData', {
                    params: {
                        isProfessional: this.isProfessionalMode,
                        userId: this.$store.state.userId,
                        pointId:this.hole.id,
                        timestampList:this.selectedTimes.join(","),
                        auth_userId:this.$store.state.auth_userId,
                        auth_timestamp:this.$store.state.auth_timestamp,
                        token:MD5(hash),
                    },
                }).then(function (res) {
                let resData = res.body.data;
                let seriesData = [];
                let xAxisData = [];
                let legendData = [];
                legendData.push('校验和标准差');
                let pointdata = [];
                for(let i = 0;i < resData.length;i++){
                    pointdata.push(Number(resData[i].aStandardDeviation));
                    xAxisData.push(resData[i].timestamp);
                }
                seriesData.push({
                    name:'校验和标准差',
                    type:'line',
                    data:pointdata
                });
                for(let i = 0;i<xAxisData.length;i++){
                    xAxisData[i] = this.utils.unixtimeToDate(xAxisData[i]*1000)
                }
                this.chartDialogStandard = true;
                setTimeout(() => {
                    this.drawStandardChart(legendData,xAxisData,seriesData);
                },0)
            }).catch(function (res) {
                this.$message(res.body.msg);
            })
        },

        //获取数据：累计变量
        getAmountChartData:function (type) {
            let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
            this.$http.get('/front/data/exportAmountDeltaSourceData', {
                    params: {
                        isProfessional: this.isProfessionalMode,
                        userId: this.$store.state.userId,
                        pointId:this.hole.id,
                        type:type,
                        timestampList:this.selectedTimes.join(","),
                        auth_userId:this.$store.state.auth_userId,
                        auth_timestamp:this.$store.state.auth_timestamp,
                        token:MD5(hash),
                    },
                }).then(function (res) {
                let resData = res.body.data;
                let seriesData = [];
                let legendData = [];
                let yAxisData = [];
                for (let item in this.selectedTimes){
                    legendData[item] = this.selectedTimes[item];
                }
                for(let i = 0;i< resData.length/legendData.length;i++){
                    yAxisData.push(Number(resData[i].depth));
                }
                yAxisData.reverse();

                legendData.splice(legendData.indexOf(resData[0].timestamp),1)
                for(let i = 0;i<resData.length/legendData.length;i++){
                    resData.shift();
                }
                for(let i = 0;i<legendData.length;i++){
                    let pointdata = [];
                    for(let j = 0;j < resData.length;j++){
                        if((legendData[i]).toString().indexOf(resData[j].timestamp) >= 0){
                            pointdata.push(Number(resData[j].amountDelta));
                        }
                    }
                    pointdata.reverse();
                    seriesData.push({
                        name:this.utils.unixtimeToDate(legendData[i]*1000),
                        type:'line',
                        data:pointdata
                    });
                }
                for(let i = 0;i<legendData.length;i++){
                    legendData[i] = this.utils.unixtimeToDate(legendData[i]*1000)
                }
                this.chartDialogAmount = true;
                setTimeout(() => {
                    this.drawChart(legendData,yAxisData,seriesData,2);
                },0)
            }).catch(function (res) {
                this.$message(res.body.msg);
            })
        },
        //获取数据：管形图
        getChartData:function (type) {
            let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
            this.$http.get('/front/data/exportTubularSourceData', {
                    params: {
                        isProfessional: this.isProfessionalMode,
                        userId: this.$store.state.userId,
                        pointId:this.hole.id,
                        timestampList:this.selectedTimes.join(","),
                        auth_userId:this.$store.state.auth_userId,
                        auth_timestamp:this.$store.state.auth_timestamp,
                        token:MD5(hash),
                    },
            }).then(function (res) {
                let resData = res.body.data;
                let seriesData = [];
                let legendData = [];
                let yAxisData = [];
                for (let item in this.selectedTimes){
                    legendData[item] = this.selectedTimes[item];
                }
                // 对数据的depth进行重新排序，以防万一
                for(let i = 0;i<legendData.length;i++){
                    for(let j = 0;j< resData.length/legendData.length;j++){
                        for(let k = j+1;k< resData.length/legendData.length;k++){
                            if(Number(resData[j + resData.length/legendData.length*i].depth) > Number(resData[k + resData.length/legendData.length*i].depth)) {
                                let temp = resData[j + resData.length/legendData.length*i];
                                resData[j + resData.length/legendData.length*i] = resData[k + resData.length/legendData.length*i];
                                resData[k + resData.length/legendData.length*i] = temp;
                            }
                        }
                    }
                }
                for(let i = 0;i< resData.length/legendData.length;i++){
                    yAxisData.push(Number(resData[i].depth));
                }
                yAxisData.reverse();
                if(type == 1){
                    for(let i = 0;i<legendData.length;i++){
                        let pointdata = [];
                        for(let j = 0;j < resData.length;j++){
                            if((legendData[i]).toString().indexOf(resData[j].timestamp) >= 0){
                                pointdata.push(Number(resData[j].profileR));
                            }
                        }
                        pointdata.reverse();
                        seriesData.push({
                            name:this.utils.unixtimeToDate(legendData[i]*1000),
                            type:'line',
                            data:pointdata
                        });
                    }
                }else {
                    for(let i = 0;i<legendData.length;i++){
                        let pointdata = [];
                        for(let j = 0;j < resData.length;j++){
                            if((legendData[i]).toString().indexOf(resData[j].timestamp) >= 0){
                                pointdata.push(Number(resData[j].profileKR));
                            }
                        }
                        pointdata.reverse();
                        seriesData.push({
                            name:this.utils.unixtimeToDate(legendData[i]*1000),
                            type:'line',
                            data:pointdata
                        });
                    }
                }

                for(let i = 0;i<legendData.length;i++){
                    legendData[i] = this.utils.unixtimeToDate(legendData[i]*1000)
                }
                this.chartDialogNormal = true;
                setTimeout(() => {
                    this.drawChart(legendData,yAxisData,seriesData,1);
                },0)
            }).catch(function (res) {
                this.$message(res.body.msg);
            })
        },
        exportTemplate:function () {
          let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
          this.$http.get('/front/data/exportTemplate',
            {
              params: {
                userId: this.$store.state.userId,
                pointId:this.hole.id,
                auth_userId:this.$store.state.auth_userId,
                auth_timestamp:this.$store.state.auth_timestamp,
                token:MD5(hash),
              },
            }
          ).then(function (res) {
            if(this.browserType == '360'){
              let a = document.getElementById("download");
              a.setAttribute("href", res.url);
              a.setAttribute("target", "view_window");
              this.dialogVisible = true;
            }else {
              window.location.href = res.url;
            }
          }).catch(function (res) {
            this.$message(res.body.msg);
          })
        },
        //导出CSV:管形图
        exportTubularData:function (type) {
            let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
            this.$http.get('/front/data/exportTubularData',
                {
                    params: {
                        isProfessional: this.isProfessionalMode,
                        userId: this.$store.state.userId,
                        pointId:this.hole.id,
                        timestampList:this.selectedTimes.join(","),
                        type:type,
                        auth_userId:this.$store.state.auth_userId,
                        auth_timestamp:this.$store.state.auth_timestamp,
                        token:MD5(hash),
                    },
                }
            ).then(function (res) {
                if(this.browserType == '360'){
                    let a = document.getElementById("download");
                    a.setAttribute("href", res.url);
                    a.setAttribute("target", "view_window");
                    this.dialogVisible = true;
                }else {
                    window.location.href = res.url;
                }
            }).catch(function (res) {
                this.$message(res.body.msg);
            })

        },
        //导出CSV:累计变量
        exportAmountDeltaData:function (type) {
            if(this.selectedTimes.length <= 1){
                this.$message('请选择两个以上时间点');
                return
            }
            let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
            this.$http.get('/front/data/exportAmountDeltaData',
                {
                    params: {
                        isProfessional: this.isProfessionalMode,
                        userId: this.$store.state.userId,
                        pointId:this.hole.id,
                        type:type,
                        timestampList:this.selectedTimes.join(","),
                        auth_userId:this.$store.state.auth_userId,
                        auth_timestamp:this.$store.state.auth_timestamp,
                        token:MD5(hash),
                    },
                }
            ).then(function (res) {
                if(this.browserType == '360'){
                    let a = document.getElementById("download");
                    a.setAttribute("href", res.url);
                    a.setAttribute("target", "view_window");
                    this.dialogVisible = true;
                }else {
                    window.location.href = res.url;
                }
            }).catch(function (res) {
                this.$message(res.body.msg);
            })
        },
        //导出CSV:校验和标准差
        exportStandard:function () {
            let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
            this.$http.get('/front/data/exportTubularData',
                {
                    params: {
                        isProfessional: this.isProfessionalMode,
                        userId: this.$store.state.userId,
                        pointId:this.hole.id,
                        timestampList:this.selectedTimes.join(","),
                        type:2,
                        auth_userId:this.$store.state.auth_userId,
                        auth_timestamp:this.$store.state.auth_timestamp,
                        token:MD5(hash),
                    },
                }
            ).then(function (res) {
                if(this.browserType == '360'){
                    let a = document.getElementById("download");
                    a.setAttribute("href", res.url);
                    a.setAttribute("target", "view_window");
                    this.dialogVisible = true;
                }else {
                    window.location.href = res.url;
                }
            }).catch(function (res) {
                this.$message(res.body.msg);
            })
        },

        //导出CSV:单次原始数据
        exportSourceData:function () {
            let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
            this.$http.get('/front/data/exportSourceData',
                {
                    params: {
                        isProfessional : this.isProfessionalMode,
                        userId         : this.$store.state.userId,
                        pointId        : this.hole.id,
                        timestampList  : this.selectedTimes.toString(),
                        auth_userId    : this.$store.state.auth_userId,
                        auth_timestamp : this.$store.state.auth_timestamp,
                        token          : MD5(hash),
                    },
                }
            ).then(function (res) {
                if(this.browserType == '360'){
                    let a = document.getElementById("download");
                    a.setAttribute("href", res.url);
                    a.setAttribute("target", "view_window");
                    this.dialogVisible = true;
                }else {
                    window.location.href = res.url;
                }
            }).catch(function (res) {
                this.$message(res.body.msg);
            })
        },
        //导出单日所有原始数据
        exportNearlyData() {
            let d = new Date(Date.parse(this.datepicker.replace(/-/g,"/")));
            if(this.datepicker == ""){
                this.$message("请选择日期！");
                return
            }else if(d > new Date()){
                this.$message("所选日期不能大于今天！");
                return
            }
            if(JSON.stringify(this.point) == '{}'){
                this.$message("请选择测量点！");
                return
            }

            let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
            this.$http.get('/front/data/exportNearlyData',
                {
                    params: {
                        isProfessional: this.isProfessionalMode,
                        userId: this.$store.state.userId,
                        pointName:this.point.label,
                        dateString:this.datepicker,
                        auth_userId:this.$store.state.auth_userId,
                        auth_timestamp:this.$store.state.auth_timestamp,
                        token:MD5(hash),
                    },
                }
            ).then(function (res) {
                if(this.browserType == '360'){
                    let a = document.getElementById("download");
                    a.setAttribute("href", res.url);
                    a.setAttribute("target", "view_window");
                    this.dialogVisible = true;
                }else {
                    window.location.href = res.url;
                }
            }).catch(function (res) {
                this.$message(res.body.msg);
            })
        },
        //全选
        handleCheckAllChange:function () {
            if(this.checkAll){
                let _this = this;
                _this.selectedTimes = [];
                _this.times.forEach(function (time) {
                    _this.selectedTimes.push(time.unixTime);
                })
            }else {
                this.selectedTimes = [];
            }
        },
        getTime:function () {
            let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
            this.$http.get('/front/data/hasDataTime',
                {
                    params: {
                        userId: this.$store.state.userId,
                        pointId:this.hole.id,
                        auth_userId:this.$store.state.auth_userId,
                        auth_timestamp:this.$store.state.auth_timestamp,
                        token:MD5(hash),
                    },
                }
            ).then(function (res) {
                this.times = res.body.data;
                if(this.times.length == 0){
                    this.$message("该测斜点下没有数据");
                }
            }).catch(function (res) {
                this.$message(res.body.msg);
            })
        },
        getPointList:function () {
            let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
            this.$http.get('/front/data/pointList',
                {
                    params: {
                        userId: this.$store.state.userId,
                        auth_userId:this.$store.state.auth_userId,
                        auth_timestamp:this.$store.state.auth_timestamp,
                        token:MD5(hash),
                    },
                }
            ).then(function (res) {
                this.tmpPointList = res.body.data;
                if(JSON.stringify(this.tmpPointList) == "{}"){
                    this.$message("该用户下没有数据");
                }
                this.pointList = [];
                for(let i = 0;i < this.tmpPointList.length;i++){
                    this.pointList.push({
                        value: this.tmpPointList[i].holeList,
                        label: this.tmpPointList[i].point
                    });
                }
            }).catch(function (res) {
                this.$message(res.body.msg);
            })
        },
        selectUser:function (user) {
            this.checkAll = false;
            if(user.id == this.$store.state.userId){
                return
            }else {
                let _this = this;
                _this.point = {};
                _this.hole = {};
                _this.suanfa = {};
                _this.times = [];
                _this.selectedTimes = [];
                localStorage.setItem("userId",user.id);
                _this.$store.commit('setUserId',user.id);
                _this.getPointList();
                _this.userList.map(function (user) {
                    user.active = false;
                    if(_this.$store.state.userId ==user.id){
                        user.active = true;
                    }
                })
            }
        },
        geiUserList:function () {
            this.point = {};
            let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
            this.$http.get('/front/user/userList',
                {
                    params: {
                        userId         : this.$store.state.auth_userId,
                        auth_userId    : this.$store.state.auth_userId,
                        auth_timestamp : this.$store.state.auth_timestamp,
                        token          : MD5(hash),
                    },
                }
            ).then(function (res) {
                let _this = this;
                _this.userList = res.body.data;
                _this.userList.map(function (user) {
                    user.active = false;
                    if(_this.$store.state.userId ==user.id){
                        user.active = true;
                    }
                })
            }).catch(function (res) {
                this.$message(res.body.msg);
            })
        },
        getBrowserInfo:function () {
            let ua = navigator.userAgent.toLocaleLowerCase();
            let browserVersion;
            if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
                this.browserType = "IE";
                browserVersion = ua.match(/msie ([\d.]+)/) != null ? ua.match(/msie ([\d.]+)/)[1] : ua.match(/rv:([\d.]+)/)[1];
            } else if (ua.match(/firefox/) != null) {
                this.browserType = "火狐";
            }else if (ua.match(/ubrowser/) != null) {
                this.browserType = "UC";
            }else if (ua.match(/opera/) != null) {
                this.browserType = "欧朋";
            } else if (ua.match(/bidubrowser/) != null) {
                this.browserType = "百度";
            }else if (ua.match(/metasr/) != null) {
                this.browserType = "搜狗";
            }else if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
                this.browserType = "QQ";
            }else if (ua.match(/maxthon/) != null) {
                this.browserType = "遨游";
            }else if (ua.match(/chrome/) != null) {
                let is360 = this.utils._mime("type", "application/vnd.chromium.remoting-viewer");

                if(is360){
                    this.browserType = '360';
                }else {
                    this.browserType = 'Chrome';
                }
            }else if (ua.match(/safari/) != null) {
                this.browserType = "Safari";
            }
            console.log(this.browserType);
        }
    },
    mounted:function () {
        this.getBrowserInfo();
        this.geiUserList();
        this.getPointList();

        $('#main-body-container').height(window.innerHeight - 60);
        // $('#aside').css('min-height',window.innerHeight - 60);
        $(window).resize(function() {
            $('#main-body-container').height(window.innerHeight - 60);
        });
    },
    watch:{
        isProfessionalMode:function(newValue,oldValue) {
            console.log('watch isProfessionalMode',newValue)
        },
        point:function (newValue,oldValue) {
            this.hole = {};
            this.times = [];
            this.selectedTimes = [];
            this.checkAll = false;
        },
        hole:function (newValue,oldValue) {
            this.selectedTimes = [];
            this.checkAll = false;

            if(JSON.stringify(this.hole) != "{}" && this.hole != undefined){
                // 将孔名作为所有图表的标题
                this.chartDialogTitle = this.hole.hole;
                this.getTime();
            }
        },
        suanfa:function (newValue,oldValue) {
            // console.log(newValue);
        }
    },
    beforeCreate () {
        myVue = this
    }
}
</script>

<style scoped>

</style>
